var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-ccd-contact-detail" },
    [
      _c("div", { staticClass: "page-head-container" }, [
        _c("div", { staticClass: "page-head clearfix" }, [
          _c("div", { staticClass: "page-head-info columns clearfix" }, [
            _c("div", { staticClass: "nav-bar" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.navBack()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            < " + _vm._s(_vm.$t("back")) + "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "page-head-project-info clearfix" }, [
              _vm.currentContact.id
                ? _c("div", { staticClass: "page-project-number" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("contact.contactNumber")) +
                        " " +
                        _vm._s(_vm.currentContact.id || "") +
                        "\n          "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row page-project-name" }, [
                _c("div", [_vm._v(_vm._s(_vm.title))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "float-right clearfix" }, [
              _vm.isAllowLink
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.linkTo()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("action.link")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.allowEdit && _vm.allowEditContact
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.enableEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("action.edit")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("action.cancel")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("action.save")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ContactInformation", {
        attrs: {
          allowEdit: _vm.allowEdit,
          contactId: _vm.contactId,
          originalContact: _vm.keep,
          inputRequireHighlight: _vm.inputRequireHighlight,
          highlightAddressIndexes: _vm.highlightAddressIndexes,
          highlightEmail: _vm.highlightEmail,
          highlightPhone: _vm.highlightPhone,
        },
      }),
      _vm._v(" "),
      _c("ContactCompany", {
        attrs: {
          allowEdit: _vm.allowEdit,
          contactId: _vm.contactId,
          contactCompany: _vm.contactCompany,
        },
      }),
      _vm._v(" "),
      _vm.isEngineer && _vm.enableTenancyRecordsFeature
        ? _c("CompanyTenancyRecord", {
            attrs: {
              allowCreate: _vm.allowEdit,
              showCreateTenancy: false,
              tenancies: _vm.tenancies,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "confirmModalBeforeSaving",
        attrs: {
          showCancelBtn: _vm.showACModalCancelBtn,
          confirmTitle: _vm.confirmMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }